import { HubRoutingWardViewModel } from "./index";

export class GetDatasFromHubViewModel {
    selectedWardIds: number[];
    wards: HubRoutingWardViewModel[];
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/getDatasFromHub.viewModel.ts